import React from 'react'
import PropTypes from 'prop-types'

function getOffsetPoint(latlng, offsetx, offsety, map) {

    const scale = Math.pow(2, map.getZoom());
    const projection = map.getProjection();
    const worldCoordinateCenter = projection.fromLatLngToPoint(latlng);
    const pixelOffset = new google.maps.Point((offsetx / scale) || 0, (offsety / scale) || 0);
    const worldCoordinateNewCenter = new google.maps.Point(
        worldCoordinateCenter.x - pixelOffset.x,
        worldCoordinateCenter.y + pixelOffset.y
    );

    return map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);
}

export default class UserLocationCircle extends React.Component {
    constructor(props) {
        super(props);
        this.positionCircle = null;
        this.accuracyCircle = null;
    }

    componentDidMount() {
        this.drawCircles();
    }

    componentDidUpdate(prevProps, prevState) {
        if (((this.props.lat != prevProps.lat) || (this.props.lng != prevProps.lng) || (this.props.accuracy != prevProps.accuracy) )) {
            this.drawCircles();
        }
    }

    drawCircles() {
        const localizationLatLng = new google.maps.LatLng(this.props.lat, this.props.lng);
        const map = this.props.map;

        // Accuracy Circle
        if (!this.accuracyCircle) {
            this.accuracyCircle = new google.maps.Circle({
                strokeColor: '#00A7E5',
                strokeOpacity: 0,
                strokeWeight: 0,
                fillColor: '#BCD4D6',
                fillOpacity: 0.5,
                map: map
            });
        }

        this.accuracyCircle.setRadius(this.props.accuracy);
        this.accuracyCircle.setCenter(localizationLatLng);

        const isMapReady = map.getProjection() != null;
        if (!isMapReady) { return; } 

        // User position circle
        if (!this.positionCircle) {
            this.positionCircle = new google.maps.Marker({
                icon: '/assets/map-circle.png',
                map: this.props.map,
                position: getOffsetPoint(localizationLatLng, 0, 10, map)
            });
        }
        this.positionCircle.setPosition(getOffsetPoint(localizationLatLng, 0, 10, map));
    }

    render() {
        return false;
    }
}

UserLocationCircle.propTypes = {
    map: PropTypes.object.isRequired,
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
    accuracy: PropTypes.number.isRequired
};